import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 92.3vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 7.3vh 0 0 0;
`;

export const Title = styled.p`
  color: #383838;
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
